export interface SearchResult {
  type: 'insider' | 'company' | 'ticker';
  id: string;
  name: string;
  subtitle?: string;
  ticker?: string;
}

const encodePathSegment = (value: string) => encodeURIComponent(value.trim());

export const getSearchResultPath = (result: SearchResult): string | null => {
  const normalizedId = result.id?.trim();
  const normalizedTicker = result.ticker?.trim();

  switch (result.type) {
    case 'insider':
      return normalizedId ? `/insiders/${encodePathSegment(normalizedId)}` : null;
    case 'ticker':
      return normalizedId ? `/companies/${encodePathSegment(normalizedId)}` : null;
    case 'company': {
      if (normalizedTicker) {
        const params = new URLSearchParams();
        if (normalizedId && normalizedId !== normalizedTicker) {
          params.set('cik', normalizedId);
        }

        const queryString = params.toString();
        return `/companies/${encodePathSegment(normalizedTicker)}${queryString ? `?${queryString}` : ''}`;
      }

      return normalizedId ? `/companies/${encodePathSegment(normalizedId)}` : null;
    }
  }
};

export const getSearchResultValue = (result: SearchResult): string =>
  [result.name, result.subtitle, result.id, result.ticker]
    .filter((value): value is string => Boolean(value))
    .join(' ');
